// extracted by mini-css-extract-plugin
export default {"layout":"Width800_layout__UMHKF","content":"Width800_content__ile1O"};